export const commonEn = {
  or: 'or',
  open: 'Open',
  setup: 'setup',
  alert: 'Warning!',
  confirm: 'Confirmation',
  loading: 'Loading...',
  enterValue: 'Enter value',
  prompt: 'Prompt',

  change: 'change',
  company: 'Company',
  project: 'Project',
  board: 'Board',
  column: 'Column',
  location: 'Location (column)',
  subtask: 'Subtask',
  subtaskOf: 'Subtask of',
  today: 'Today',
  addMore: 'Add more',
  newProjectTitle: 'New Project',
  projectEmptyError: 'Project name must be specified',
  moreChats: 'More chats',
  attention: 'Warning',
  attentionWithExclamation: 'Warning!',
  send: 'Send',
  chooseAll: 'Choose all',
  chooseNoone: 'nobody',
  byDepartment: 'By department',
  byAlphabet: 'By alphabet',
  setupRole: 'Setup role',
  fileSizeWarn: (maxSizeMb: number) =>
    `Uploaded files should be smaller than ${maxSizeMb} Mb`,
  serverFailTryLater:
    'Failed to get response from server, please try again later',
  cancelSync: 'Cancel sync',
  disable: 'Disable',
  enableSync: 'Enable Sync',
  dontShowMessageAgain: "Don't show this message again"
}

export const commonRu: typeof commonEn = {
  or: 'или',
  open: 'Открыть',
  setup: 'Настроить',
  alert: 'Предупреждение',
  confirm: 'Подтверждение',
  loading: 'Загрузка...',
  enterValue: 'Введите значение',
  prompt: 'Ввод знанения',
  change: 'изменить',
  company: 'Компания',
  project: 'Проект',
  board: 'Доска',
  column: 'Колонка',
  location: 'Расположение (колонка)',
  subtask: 'Подзадача',
  subtaskOf: 'Подзадача задачи',
  today: 'Сегодня',
  addMore: 'Добавить ещё',
  newProjectTitle: 'Новый проект',
  projectEmptyError: 'Название проекта не должно быть пустым',
  moreChats: 'Ещё чатов',
  attention: 'Внимание',
  attentionWithExclamation: 'Внимание!',
  send: 'Отправить',
  chooseAll: 'Выбрать всех',
  chooseNoone: 'никого',
  byDepartment: 'По отделам',
  byAlphabet: 'По алфавиту',
  setupRole: 'Установить роль',
  fileSizeWarn: (maxSizeMb: number) =>
    `Загружаемые файлы должны быть не более ${maxSizeMb} Мб`,
  serverFailTryLater:
    'Не удалось получить ответ от сервера, пожалуйста, попробуйте позже',
  cancelSync: 'Отменить синхронизацию',
  disable: 'Отключить',
  enableSync: 'Включить синхронизацию',
  dontShowMessageAgain: 'Больше не показывать это сообщение'
}
